var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.11916 0.759695C9.25129 0.881751 9.35233 1.04877 9.35233 1.21625C9.35233 1.36745 9.29769 1.51861 9.18719 1.63826L2.14968 9.2974L9.18719 16.9565C9.42034 17.2091 9.40577 17.6032 9.15195 17.8351C8.89936 18.0683 8.50729 18.0525 8.27412 17.8005L0.813056 9.71783C0.592032 9.47862 0.592032 9.11319 0.813056 8.87381L8.27412 0.791108C8.4741 0.542316 8.86658 0.52654 9.11916 0.759695Z","fill":"currentColor"}));
}

ChevronLeft.defaultProps = {"width":"10","height":"18","viewBox":"0 0 10 18","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
